import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { ExperimentService } from '@services/experiment/experiment.service';

/** Without the experiment these routes do not match, so the single-page control form is served. */
export const onboardingProfileBreakdownGuard: CanMatchFn = async (): Promise<boolean> => {
  const experimentService = inject(ExperimentService);
  await experimentService.experimentsLoaded;
  return experimentService.isUserProfileInputBreakdownEnabled();
};

/** The age page additionally disappears under the `skip_age_page` variant. */
export const onboardingAgePageGuard: CanMatchFn = async (): Promise<boolean> => {
  const experimentService = inject(ExperimentService);
  await experimentService.experimentsLoaded;
  if (!experimentService.isUserProfileInputBreakdownEnabled()) return false;
  return !experimentService.shouldSkipAgePage();
};
